import './PercentProgress.scss';

const getColor = (value) => {
    const clampedValue = Math.min(100, Math.max(0, value));
    const green = Math.round((clampedValue / 100) * 255);
    const red = 255 - green;  
    return `rgb(${red}, ${green}, 0)`;
  }

interface PercentProgressProps {
    percent:number
}
function PercentProgress({percent}:PercentProgressProps) {
    let color = getColor(percent);
    return <span className='percent-progress' style={{color: color}}>{percent}%</span>;
}

export default PercentProgress;